<template>
    <!-- SIMULATION -->
    <div class="md-layout-item md-size-100">
        <md-card class="pl-1 pr-1">
            <md-card-header class=" pb-0">
                <h4 class="title pt-1">
                    Simulação
                </h4>
            </md-card-header>
            <md-card-content class="pb-2">
                <div class="md-layout" v-if="!simulationLoading">
                    <div
                        class="md-layout-item md-layout md-alignment-top-left list-content"
                    >
                        <div
                            class="md-layout-item md-size-25 md-small-size-100 md-medium-size-50 md-alignment-top-space-between"
                        >
                            <b>ID:</b>
                            <span class="item-content">{{
                                simulation.id
                            }}</span>
                        </div>
                        <div
                            class="md-layout-item md-size-25 md-small-size-100 md-medium-size-50 md-alignment-top-space-between"
                        >
                            <b>Data:</b>
                            <span class="item-content">{{
                                new Date(
                                    simulation.datetime_created
                                ).toLocaleString()
                            }}</span>
                        </div>
                        <div
                            class="md-layout-item md-size-25 md-small-size-100 md-medium-size-50 md-alignment-top-space-between"
                        >
                            <b>PDV 90D:</b>
                            <span class="item-content">{{
                                simulation.pvd_90_price
                            }}</span>
                        </div>
                        <div
                            class="md-layout-item md-size-25 md-small-size-100 md-medium-size-50 md-alignment-top-space-between"
                        >
                            <b>Custo estoque:</b>
                            <span class="item-content">{{
                                simulation.stock_cost
                            }}</span>
                        </div>
                        <div
                            class="md-layout-item md-size-25 md-small-size-100 md-medium-size-50 md-alignment-top-space-between"
                        >
                            <b>Margem Lucro:</b>
                            <span class="item-content">
                                {{ simulation.profit_margin }}
                            </span>
                        </div>
                        <div
                            class="md-layout-item md-size-25 md-small-size-100 md-medium-size-50 md-alignment-top-space-between"
                        >
                            <b>Total de Peças:</b>
                            <span class="item-content">{{
                                simulation.stock_count
                            }}</span>
                        </div>
                        <div
                            class="md-layout-item md-size-25 md-small-size-100 md-medium-size-50 md-alignment-top-space-between"
                        >
                            <b>TC:</b>
                            <span class="item-content">{{
                                simulation.coverage
                            }}</span>
                        </div>
                        <div
                            class="md-layout-item md-size-25 md-small-size-100 md-medium-size-50 md-alignment-top-space-between"
                        >
                            <b>Curva:</b>
                            <span class="item-content">{{
                                simulation.curve
                            }}</span>
                        </div>
                    </div>
                </div>

                <div class="text-center mt--2 pb-2" v-else>
                    <img src="loader.svg" style="width: 100px; height: 100px" />
                </div>
            </md-card-content>
        </md-card>
    </div>
</template>

<script>
export default {
    props: ['simulationLoading', 'simulation']
}
</script>
<style lang="scss" scoped>
.list-content {
    .item-content {
        float: right;
    }
}
</style>
